import { useMutation } from '@tanstack/react-query';

import { getFaireVersementJustificatifsCodeEmail } from '@/services/getFaireVersementJustificatifsCodeEmail/getFaireVersementJustificatifsCodeEmail';
import { log } from '@/utils/functions/logger/logger';

export const useFaireVersementJustificatifsCodeEmail = () => {
  return useMutation({
    mutationFn: getFaireVersementJustificatifsCodeEmail,

    onError: (error) => {
      log.error(`useFaireVersementJustificatifsCodeEmail failed: ${error}`);
    },
  });
};
